import React, { memo, useRef, useState, useEffect } from "react";
import cls from "classnames";

import { SpuSaleInfoType, SkuInfoType } from "../../types";

import SpecSelect from "./utils/SpecSelect";
import { AdjoinType } from "./utils/types";
import styles from "./styles.scss";

export type SelectAttrType = {
  item?: SkuInfoType;
  standardNames?: string[] | null;
  isSingleSku?: boolean;
  unselectPropNames?: string;
};

const mapToSortArr = (map: Map<number, string>): string[] => {
  if (!map) return [];
  const arr = new Array(map.size).fill("");
  for (const [index, val] of map.entries()) {
    arr[index] = val;
  }
  return arr.filter(Boolean);
};

type Props = {
  skuInfos: SkuInfoType[];
  spuSaleInfos: SpuSaleInfoType[];
  onSelect?: (attrs: SelectAttrType | null) => void;
  defaultSelect?: string[] | null;
};

const SkuSelect: React.FC<Props> = (props) => {
  const { skuInfos, spuSaleInfos, defaultSelect } = props;
  const specAdjoinMatrixRef = useRef<SpecSelect>();
  const selectNames = useRef<Map<number, string>>(new Map());
  const [specsS, setSpecsS] = useState<AdjoinType>([]);
  const [optionSpecs, setOptionSpecs] = useState<AdjoinType>([]);

  useEffect(() => {
    if (!skuInfos || !spuSaleInfos || (defaultSelect && defaultSelect?.length !== spuSaleInfos.length)) return;
    // 默认选中项
    const specs: AdjoinType = defaultSelect || new Array(spuSaleInfos.length).fill("");
    const specAdjoinMatrix = new SpecSelect(spuSaleInfos, skuInfos);
    specAdjoinMatrixRef.current = specAdjoinMatrix;
    setSpecsS(specs);
    setOptionSpecs(specAdjoinMatrixRef.current.getSpecsOptions(specs));
  }, [skuInfos, spuSaleInfos, defaultSelect]);

  const onClick = (text: string, index: number, propName: string): void => {
    const bool = optionSpecs.includes(text); // 当前规格是否可选
    // 排除可选规格里面没有的规格
    const specsSTemp = specsS.slice();
    if (specsSTemp[index] !== text && !bool) return;
    // 根据text判断是否已经被选中了
    specsSTemp[index] = specsSTemp[index] === text ? "" : text;
    setSpecsS(specsSTemp);
    if (specAdjoinMatrixRef.current) {
      const result = specAdjoinMatrixRef.current.getSpecsOptions(specsSTemp);
      setOptionSpecs(result);
      const names = specsSTemp.filter((item) => !!item);
      // 没选中所有属性 不更新选中 sku
      // const isSelectAllProp = names.length === specsSTemp.length;
      const item = skuInfos.find((item) =>
        spuSaleInfos.every((info, i) => item.properties[info.name] === specsSTemp[i])
      );

      // 用于计算哪个属性未选中。
      if (specsSTemp[index]) {
        selectNames.current.delete(index);
      } else {
        selectNames.current.set(index, propName);
      }
      // 选中全部属性就自动跳转
      // props?.onSelect?.(
      //   names.length > 0
      //     ? { item, standardNames: names, unselectPropNames: mapToSortArr(selectNames.current)?.[0] }
      //     : null
      // );
      props?.onSelect?.({
        item,
        standardNames: names.length > 0 ? names : null,
        unselectPropNames: mapToSortArr(selectNames.current)?.[0],
      });
    }
  };

  return (
    <>
      {spuSaleInfos?.map((item, index) => {
        return (
          <React.Fragment key={item.name}>
            <div className={cls(styles.props_title, "al_font_bold")}>{item.name}</div>
            <div className={styles.props_wrapper}>
              {item.values?.map((el, i) => {
                return (
                  <button
                    key={i}
                    className={cls(styles.props_button, {
                      al_font_bold: specsS[index] === el,
                      [styles.active]: specsS[index] === el,
                    })}
                    disabled={!optionSpecs.includes(el)}
                    type="button"
                    onClick={onClick.bind(null, el, index, item.name)}
                  >
                    {el}
                  </button>
                );
              })}
            </div>
          </React.Fragment>
        );
      })}
    </>
  );
};

export default memo(SkuSelect);
